import { State } from '../../@types/state';
import { SnackbarMessage } from '../../@types/state/snackbar';

export function selectSnackbarQueue(state: State): SnackbarMessage[] {
  return state.snackbar.snackbarQueue;
}
